import ReduxInterface from 'Editor/services/ReduxInterface/ReduxInteface';
import EditorManager from 'Editor/services/EditorManager';
import { DISPLAY_TYPES, ELEMENTS } from 'Editor/services/consts';

import './HyperlinkElement.module.scss';
import { BaseViewElement } from '../../BaseViewBuilder';

export const ATTRIBUTES = ['href', 'anchor'] as const;
// const ATTRIBUTES_LENGTH = ATTRIBUTES.length;

export class HyperlinkElement extends BaseViewElement {
  static get observedAttributes() {
    return ['href'];
  }

  constructor(Visualizer?: Editor.Visualizer.State, Data?: Editor.Data.API) {
    super(Visualizer, Data);

    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);

    this.handleOnTooltipClick = this.handleOnTooltipClick.bind(this);
  }

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('click', this.handleOnTooltipClick);
    this.addEventListener('mouseenter', this.onMouseEnter);
    this.addEventListener('mouseleave', this.onMouseLeave);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleOnTooltipClick);
    this.removeEventListener('mouseenter', this.onMouseEnter);
    this.removeEventListener('mouseleave', this.onMouseLeave);

    super.disconnectedCallback();
  }

  attributeChangedCallback(attribute: string, oldValue: string, newValue: string) {
    if (oldValue !== newValue) {
      switch (attribute) {
        case 'href':
          this.href = newValue;
          break;
        default:
          break;
      }
    }
  }

  private handleOnTooltipClick() {
    if (this.dataset.anchor) {
      EditorManager.getInstance().handleCrossReferenceSelected(this.dataset.anchor);
    }
  }

  get displayType() {
    return DISPLAY_TYPES.INLINE;
  }

  get isEditable() {
    return true;
  }

  get isDeletable() {
    return true;
  }

  get isSplitable() {
    return true;
  }

  get isContentWrapper() {
    return false;
  }

  get isSelectable() {
    return true;
  }

  get href() {
    return this.dataset.href;
  }

  set href(value) {
    if (value != null) {
      this.dataset.href = value;
    }
  }

  select() {
    this.setAttribute('selected', 'true');
  }

  deselect() {
    this.removeAttribute('selected');
  }

  private showHyperlinkTooltip() {
    let shortcut;
    if (ReduxInterface.getPlatformInfo().os.mac) {
      shortcut = '⌘ + Click';
    } else {
      shortcut = 'Ctrl + Click';
    }

    const widgetsManager = this.Visualizer?.getWidgetsManager?.();
    if (widgetsManager) {
      widgetsManager.addWidget('tooltip', this, {
        content: 'TOOLTIP_LINK_SHORTCUT',
        shortcut,
        testId: this.id,
      });
    }
  }

  private showCrossRefTooltip() {
    const widgetsManager = this.Visualizer?.getWidgetsManager?.();
    if (widgetsManager) {
      widgetsManager.addWidget('tooltip', this, {
        content: 'GO_TO_ELEMENT',
        testId: this.id,
      });
    }
  }

  onMouseEnter() {
    if (this.dataset.anchor) {
      //! WARN temporary
      this.showCrossRefTooltip();
    } else {
      this.showHyperlinkTooltip();
    }
  }

  onMouseLeave() {
    const widgetsManager = this.Visualizer?.getWidgetsManager?.();
    if (widgetsManager) {
      widgetsManager.removeWidget('tooltip', this.id);
    }
  }
}

if (!window.customElements.get(ELEMENTS.HyperlinkElement.IDENTIFIER)) {
  window.customElements.define(ELEMENTS.HyperlinkElement.IDENTIFIER, HyperlinkElement);
}
